webpackJsonp([202660965941462],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__(18);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _DrJava = __webpack_require__(143);
	
	var _DrJava2 = _interopRequireDefault(_DrJava);
	
	var _ClintonCollege = __webpack_require__(141);
	
	var _ClintonCollege2 = _interopRequireDefault(_ClintonCollege);
	
	var _UnityPoint = __webpack_require__(142);
	
	var _UnityPoint2 = _interopRequireDefault(_UnityPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkStyle = {
	  height: '400px',
	  overflow: 'hidden',
	  position: 'relative',
	  zIndex: '1',
	  border: '10px solid white'
	};
	
	var imgStyle = {
	  height: '400px',
	  width: 'auto',
	  maxWidth: 'none',
	  position: 'absolute',
	  top: '0',
	  left: '0'
	};
	
	var overlayStyle = {
	  color: 'white',
	  zIndex: '2',
	  position: 'absolute',
	  top: '0',
	  left: '0',
	  right: '0',
	  bottom: '0',
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'center'
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'container content', id: 'content' },
	      _react2.default.createElement(
	        'section',
	        { className: 'section has-text-centered' },
	        _react2.default.createElement(
	          'h1',
	          { style: { textAlign: 'left' } },
	          'Projects'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'We use top quality laminates in all our casework.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'These laminates are available in numerous colors and finishes. To review available laminate or solid surface colors, visit Wilsonart\xAE, Formica\xAE, Nevamar\xAE and Pionite\xAE.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/commercial', className: 'column', style: linkStyle },
	            _react2.default.createElement('img', { src: _DrJava2.default, alt: 'Commercial', style: imgStyle }),
	            _react2.default.createElement(
	              'div',
	              { className: 'overlay is-size-3', style: overlayStyle },
	              'Commercial'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/educational', className: 'column', style: linkStyle },
	            _react2.default.createElement('img', { src: _ClintonCollege2.default, alt: 'Educational', style: imgStyle }),
	            _react2.default.createElement(
	              'div',
	              { className: 'overlay is-size-3', style: overlayStyle },
	              'Educational'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/healthcare', className: 'column', style: linkStyle },
	            _react2.default.createElement('img', { src: _UnityPoint2.default, alt: 'Healthcare', style: imgStyle }),
	            _react2.default.createElement(
	              'div',
	              { className: 'overlay is-size-3', style: overlayStyle },
	              'Healthcare'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ClintonCollege.0b7a9f98.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/UnityPoint.04e10c03.jpg";

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DrJava.47f94a7f.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-index-js-0990ae2f67074f081108.js